function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.287,
    height: 8.618,
    viewBox: "0 0 8.287 8.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4 0.566)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#4a4f55"
    },
    d: "M7.5,18h7.487",
    transform: "translate(-7.5 -14.257)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#4a4f55",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8px"
    },
    d: "M7.5,14.987l3.743-3.743L7.5,7.5",
    transform: "translate(-3.757 -7.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.03f88c55808946471d044a284f397e08.svg";
export { ForwardRef as ReactComponent };